import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { toast } from '../../../lib/toast';
import { updateUser, type UpdateUserRequest } from '../api/users';

export function useUpdateUser(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, data }: { userId: string; data: UpdateUserRequest }) =>
      updateUser(userId, data),
    onSuccess: (_data, { userId }) => {
      void invalidateListResource(queryClient, 'users');
      void queryClient.invalidateQueries({ queryKey: ['user', userId] });
      toast.success('User updated');
      onSuccess?.();
    },
    onError: () => toast.error('Failed to update user'),
  });
}
